export const SUBMIT_SURVEY = "SUBMIT_SURVEY"
export const SUBMIT_SURVEY_SUCCESS = "SUBMIT_SURVEY_SUCCESS"
export const SUBMIT_SURVEY_FAIL = "SUBMIT_SURVEY_FAIL"